/* eslint-disable */
import * as React from 'react';
import { Article } from './Article';
import { QueryProvider } from '@thd-nucleus/data-sources';

export const Home = () => {
  return (
    <QueryProvider cacheKey='home'>
      <Article />
    </QueryProvider>
  );
};

Home.propTypes = {
};

Home.displayName = 'HomePage';

Home.defaultProps = {
  name: '',
};
